import { Component, ChangeDetectionStrategy, input, signal, inject, effect } from '@angular/core';
import { FileUploaderService } from '../../services/file-uploader.service';

@Component({
  selector: 'xmed-image-view',
  standalone: true,
  imports: [],
  templateUrl: './image-view.component.html',
  styleUrl: './image-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageViewComponent {
  private readonly uploader = inject(FileUploaderService);

  fileKey = input.required<string>();
  legacy = input(false);

  imageUrl = signal('');

  constructor() {
    effect(() => {
      const key = this.fileKey();
      if (key?.length) {
        this.loadImage(key, this.legacy());
      } else {
        this.imageUrl.set('');
      }
    });
  }

  private loadImage(key: string, legacy: boolean): void {
    if (legacy) {
      this.uploader.getSignedUrl(key, 'GET', 300).subscribe({
        next: (url) => this.imageUrl.set(url),
        error: (err) => console.error('Failed to load image:', err)
      });
    } else {
      this.uploader.getSignedAssetsUrl(key, 'GET', 300).subscribe({
        next: (url) => this.imageUrl.set(url),
        error: (err) => console.error('Failed to load image:', err)
      });
    }
  }
}
